export const usercentricsServiceStatus = (usercentricsServiceName) => {
  return (
    window.UC_UI &&
    Boolean(
      window.UC_UI.getServicesBaseInfo().find((service) => service.name === usercentricsServiceName)?.consent?.status
    )
  );
};
